import React, {
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
  useCallback,
  useContext,
  FC,
} from 'react';
import { useLocation } from 'react-router-dom';
import { MenuCategories } from 'view/molecules/MenuCategories';
import { SideBarContentType } from 'interfaces/header.model';
import { SearchList } from '../SearchList';
import { checkClick } from './utils/utils';
import { HeaderContext } from '../HeaderContext';
import * as S from './SideBar.styles';

export const SideBar: FC = () => {
  const location = useLocation();

  const [isMounted, setIsMounted] = useState(false);

  const { isSideBarOpen, sideBarContentType, closeSideBar } =
    useContext(HeaderContext);

  const sideBarDOM = useRef<HTMLDivElement | null>(null);

  const path = location.pathname;

  useEffect(() => {
    if (isSideBarOpen) setIsMounted(true);
  }, [isSideBarOpen]);

  const handleOutSideClick = useCallback(
    (e: Event) => {
      if (path === '/discount-editor') return;
      checkClick(e, 'safe-to-click', closeSideBar);
    },
    [path, closeSideBar],
  );

  useLayoutEffect(() => {
    if (isSideBarOpen) {
      document.addEventListener('click', handleOutSideClick);
    }

    return () => {
      document.removeEventListener('click', handleOutSideClick);
    };
  }, [isSideBarOpen, handleOutSideClick]);

  const unmount = () => {
    if (!isSideBarOpen) setIsMounted(false);
  };

  return isMounted ? (
    <S.Container open={isSideBarOpen} onAnimationEnd={unmount} ref={sideBarDOM}>
      <S.StyledMenu className='safe-to-click'>
        {sideBarContentType === SideBarContentType.menu ? (
          <MenuCategories />
        ) : (
          <SearchList />
        )}
      </S.StyledMenu>
    </S.Container>
  ) : null;
};
